








































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { filterDeburr } from '../../utils/functions';

import { Exame } from '../../../../back/src/entity/Exame';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import {
  StatusExame, ResultadoDeExameFormData, ResponseObj, OpcaoStatus,
} from '../../../../back/src/types';

export default Vue.extend({
  name: 'ResultadosDeExamesForm',
  props: {
    exames: {
      type: Array as () => Exame[],
    },
    resultadoDeExame: {
      type: Object as () => ResultadoDeExame,
    },
  },
  data() {
    return {
      loading: false,
      menuDataExame: false,
      valid: false,
      searchInput: '',
      form: {
        nomeExame: this.resultadoDeExame.nome_exame,
        dataExame: moment(this.resultadoDeExame.data_exame || '').isValid()
          ? moment(this.resultadoDeExame.data_exame || '').format('YYYY-MM-DD')
          : '',
        resultado: this.resultadoDeExame.resultado,
        status: this.resultadoDeExame.status,
        observacoes: this.resultadoDeExame.observacoes,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    formResultadoDeExame():
      Vue & { validate: () => boolean, reset: () => void, resetValidation: () => void } {
      return this.$refs.formResultadoDeExame as Vue & {
        validate: () => boolean,
        reset: () => void,
        resetValidation: () => void
      };
    },
    dataExameFormatada(): string {
      if (this.form.dataExame) {
        const momentData = moment(this.form.dataExame);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    opcoesResultados(): { value: string, text: string }[] {
      if (this.resultadoDeExame.exame_id) {
        if (!this.resultadoDeExame.exame.opcoes_resultados) {
          return [];
        }
        return _.map(
          this.resultadoDeExame.exame.opcoes_resultados as string[],
          opcao => ({ value: opcao, text: opcao }),
        );
      }
      return [];
    },
    opcoesStatus(): { value: string, text: string, color: string }[] {
      if (this.resultadoDeExame.exame_id) {
        if (!this.resultadoDeExame.exame.opcoes_status) {
          return [];
        }
        return _.map(
          this.resultadoDeExame.exame.opcoes_status as OpcaoStatus[],
          opcao => ({ value: opcao.status, text: opcao.status, color: opcao.color }),
        );
      }
      return [
        { value: 'Normal', text: 'Normal', color: 'success' },
        { value: 'Alterado', text: 'Alterado', color: 'error' },
      ];
    },
  },
  methods: {
    filterDeburr(item: any, queryText: string, itemText: string) {
      return filterDeburr(queryText, itemText);
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formResultadoDeExame.validate()) {
        this.loading = false;
        return;
      }
      const formData: ResultadoDeExameFormData = {
        id: this.resultadoDeExame.id,
        exame_id: this.resultadoDeExame.exame_id,
        nome_exame: this.resultadoDeExame.exame_id ? '' : this.form.nomeExame,
        gestacao_id: this.resultadoDeExame.gestacao_id,
        paciente_id: this.resultadoDeExame.paciente_id,
        data_exame: moment(this.form.dataExame).isValid()
          ? moment(this.form.dataExame).toDate()
          : null,
        resultado: this.form.resultado || null,
        status: this.form.status,
        observacoes: this.form.observacoes || null,
      };
      try {
        const response = await Requester.resultadoDeExame.atualizaResultadoExame(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso' });
          this.$emit('atualizaResultadoDeExame', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
